import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';


export const useMenuItem = () => {
    const navigate = useNavigate();

    return useCallback((path: string) => {
        return () => navigate(path);
    }, [navigate]);
}

export const useDialog = () => {
    const [open, setOpen] = useState(false);

    const hanldeOpen = useCallback(() => {
        setOpen(true);
    }, []);

    const handleClose = useCallback(() => {
        setOpen(false);
    }, []);

    return { open, hanldeOpen, handleClose }
}
